import ResultsServiceModel from '@/models/ResultsServiceModel'

export default class ResultSharingModel extends ResultsServiceModel {
  modelName () {
    return 'result-shares'
  }

  defaults () {
    return {
      id: null,
      customer_id: null,
      customer_share_id: null,
      share_code: null,
      sample_type_id: null,
      grower: null,
      field: null,
      zone: null,
      crop_type: null,
      crop_stage: null,
      storage_bin: null,
      starts_at: null,
      ends_at: null,
      created_at: null,
      updated_at: null,
      deleted_at: null
    }
  }

  mutations () {
    return {
      id: val => this.nullStringMutator(val),
      customer_id: val => this.nullStringMutator(val),
      customer_share_id: val => this.nullStringMutator(val),
      share_code: val => this.nullStringMutator(val),
      sample_type_id: val => this.nullStringMutator(val),
      grower: val => this.nullStringMutator(val),
      field: val => this.nullStringMutator(val),
      zone: val => this.nullStringMutator(val),
      crop_type: val => this.nullStringMutator(val),
      crop_stage: val => this.nullStringMutator(val),
      storage_bin: val => this.nullStringMutator(val),
      starts_at: val => (val ? this.nullStringMutator(val) : undefined),
      ends_at: val => (val ? this.nullStringMutator(val) : undefined),
      created_at: val => this.nullStringMutator(val),
      updated_at: val => this.nullStringMutator(val),
      deleted_at: val => this.nullStringMutator(val)
    }
  }
}
